import React from "react";

const FacebookIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        id="Vector"
        d="M24 12C24 5.37242 18.6276 0 12 0C5.37242 0 0 5.37242 0 12C0 17.628 3.87442 22.3497 9.10114 23.6468V15.667H6.62664V12H9.10114V10.42C9.10114 6.33525 10.9495 4.44212 14.9592 4.44212C15.7198 4.44212 17.0315 4.59159 17.5681 4.74059V8.06475C17.2847 8.03505 16.7929 8.01996 16.1818 8.01996C14.2142 8.01996 13.4537 8.76542 13.4537 10.7033V12H17.3734L16.7 15.667H13.4537V23.9123C19.3957 23.1947 24 18.1353 24 12Z"
        fill="white"
      />
      <path
        id="Vector_2"
        d="M16.7 15.667L17.3734 12H13.4537V10.7034C13.4537 8.76544 14.2142 8.01998 16.1819 8.01998C16.7929 8.01998 17.2847 8.03507 17.5681 8.06477V4.74061C17.0315 4.59161 15.7198 4.44214 14.9592 4.44214C10.9495 4.44214 9.10115 6.33573 9.10115 10.42V12H6.62665V15.667H9.10115V23.6469C10.0296 23.877 11.0004 24 12 24C12.4923 24 12.977 23.9698 13.4537 23.9123V15.667H16.7Z"
        fill="#0866FF"
      />
    </svg>
  );
};

export default FacebookIcon;